import { render, staticRenderFns } from "./debtor-asset.vue?vue&type=template&id=247b1158&scoped=true&"
import script from "./debtor-asset.vue?vue&type=script&lang=js&"
export * from "./debtor-asset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247b1158",
  null
  
)

export default component.exports